import { useParams } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n";
import { LEGAL_CONTENT } from "@/legalContent";

function Body({ text }) {
  const parts = String(text).split(/(\[\[[^\]]+\]\])/g);
  return (
    <p className="text-sm leading-relaxed text-slate-400">
      {parts.map((part, i) =>
        part.startsWith("[[") ? (
          <span key={i} className="inline-flex items-center gap-1 rounded-sm border border-[#D946EF]/60 bg-[#D946EF]/10 px-1 font-mono2 text-[11px] font-bold text-[#D946EF]">
            <AlertTriangle className="h-3 w-3" /> {part.slice(2, -2)}
          </span>
        ) : (
          <span key={i}>{part}</span>
        )
      )}
    </p>
  );
}

export default function LegalPage({ forcedSlug }) {
  const { slug } = useParams();
  const { lang } = useI18n();
  const key = forcedSlug || slug;
  const pages = LEGAL_CONTENT[lang] || LEGAL_CONTENT.en;
  const page = pages[key] || LEGAL_CONTENT.en[key];
  if (!page) {
    return <p className="pt-16 text-center text-sm text-slate-500">404</p>;
  }
  return (
    <article className="mx-auto max-w-3xl pt-10" data-testid={`legal-page-${key}`}>
      <h1 className="mb-2 border-b border-[#1F293D] pb-4 font-display text-3xl font-black uppercase tracking-tight text-slate-50 sm:text-4xl">
        {page.title}
      </h1>
      <p className="mb-8 font-mono2 text-[10px] uppercase tracking-widest text-slate-600">Rookie Radar — FPV FLY, SAS</p>
      <div className="space-y-8">
        {page.sections.map((s) => (
          <section key={s.h}>
            <h2 className="mb-3 border-l-2 border-[#D946EF] pl-3 font-display text-lg font-bold uppercase tracking-tight text-slate-100">
              {s.h}
            </h2>
            <div className="space-y-2 pl-3">
              {s.body.map((p, i) => <Body key={i} text={p} />)}
            </div>
          </section>
        ))}
      </div>
    </article>
  );
}
